import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { OverduePaymentButtonManager, OverduePaymentButtonPageStore } from '@ctct/application-layer';
import type { OverduePaymentButtonHooks } from '@ctct/state-client-layer';
import { usePayOverdueBalanceMutation } from '@ctct/state-server-layer';

interface Props {
  initializer: Pick<OverduePaymentButtonManager, 'overduePaymentButtonInit'>;
  pageStore: OverduePaymentButtonPageStore;
  hooks: OverduePaymentButtonHooks;
}

export const useOverduePaymentButtonWidget = ({ initializer, pageStore, hooks }: Props) => {
  const { t } = useTranslation();
  const payOverdueBalance = usePayOverdueBalanceMutation();

  const componentProps = useMemo(() => {
    const initedManagerReturnValue = initializer.overduePaymentButtonInit({
      pageStore,
      mutations: [payOverdueBalance],
      t,
    });

    return {
      ...initedManagerReturnValue,
      hooks,
    };
  }, [initializer, pageStore, payOverdueBalance, t, hooks]);

  return componentProps;
};

export type OverduePaymentButtonWidgetProps = ReturnType<typeof useOverduePaymentButtonWidget>;
